import React from 'react';
import {showModal} from '../actions';
import {store} from '../store';
import http_build_query from "locutus/php/url/http_build_query";
import objectToFormData from "./object-to-formdata";
import axios from "axios";
import contentDisposition from 'content-disposition';

export const trace = (object) => {
    if (object.error) {
        const error = object.error;

        const subTrace = (trace) => {
            return (trace || []).map((error, i) => {
                return <div key={i}>
                    {error.class}{(error.function ? "->" + error.function : "")} in {error.file} on <b>{error.line}</b>
                </div>;
            });
        };

        return [
            <div key={0}>
                <b>{error.type}<br/>{error.message}</b> in {error.file} on <b>{error.line}</b>
            </div>,
            <div key={1}>
                {subTrace(error.trace)}
            </div>
        ];
    }
}

const requestConfig = {nullsAsUndefineds: '_null', emptyArrayAs: '_array', indices: true};

class requestObj {
    obj = {};
    append = (key, value) => {
        this.obj[key] = value;
    }
}

export const paramsSerializer = (params) => {
    const getObj = new requestObj();
    params = JSON.parse(JSON.stringify(params));
    params = objectToFormData(params, requestConfig, getObj).obj;
    return http_build_query(params);
};

export const rawRequest = (url, method, requestParams, postParams, options) => {
    let cancel = null;
    const CancelToken = axios.CancelToken;
    const requestId = "r" + new Date().getTime();
    //store.dispatch(startPace(requestId));

    let headers = {};
    if (options.customHeaders) {
        headers = options.customHeaders;
    } else if (options.headers !== false) {
        headers = { 'Content-Type': options.contentType || 'multipart/form-data', 'X-Requested-With': 'XMLHttpRequest' };
    }

    const request = axios({
        onUploadProgress: (progressEvent) => {
            let percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
            //store.dispatch(setPacePercent(requestId, null, percentCompleted));
        },
        onDownloadProgress: (progressEvent) => {
            let percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
            //store.dispatch(setPacePercent(requestId, percentCompleted, null));
        },
        cancelToken: new CancelToken((c) => {
            // An executor function receives a cancel function as a parameter
            cancel = c;
        }),
        method: method,
        url,
        timeout: 1000 * 60 * 5, // 5 minutes
        headers,
        paramsSerializer: (params) => {
            const getObj = new requestObj();
            params = JSON.parse(JSON.stringify(params));
            params = options.paramParser ? options.paramParser(params) : objectToFormData(params, requestConfig, getObj).obj;
            return http_build_query(params);
        },
        params: {...requestParams, '_': new Date().getTime()}, // for no cache
        data: options.paramParser ? options.paramParser(postParams) : objectToFormData(postParams, requestConfig),
        responseType: 'blob', // important
    });
    request.catch((e) => {
        if (!(e instanceof axios.Cancel) && e.message) {
            console.error(e);
            const finish = (e) => {
                if ((e.response.data || {}).error) {
                    const error = e.response.data;

                    store.dispatch(showModal({
                        size: "large",
                        theme: "danger",
                        header: "Szerveroldali hiba",
                        body: trace(error)
                    }));
                } else if ((e.response.data || {}).msg) {
                    store.dispatch(showModal({
                        size: "large",
                        theme: e.response.data.success === false ? "warning" : "default",
                        header: "Rendszer hiba",
                        body: e.response.data.msg
                    }));
                } else {
                    store.dispatch(showModal({
                        theme: "danger",
                        header: "Szerveroldali hiba",
                        text: e.message
                    }));
                }
            }
            if (options.showError === undefined || options.showError) {
                const reader = new FileReader();
                reader.onload = () => {
                    /*if (type.indexOf("json") !== -1 || type === null) {
                        response.data = JSON.parse(reader.result);
                    } else {
                        response.data = reader.result;
                    }*/
                    try {
                        e.response.data = JSON.parse(reader.result);
                    } catch (_e) {
                        e.response.data = reader.result;
                    }
                    finish(e);
                };
                reader.readAsText(e.response.data);
            }
        }
    });
    const r = new Promise((resolve, reject) => {
        request.then((response) => {
            const finish = (response) => {
                //saveAs(new Blob([response.data], {type: }));
                //store.dispatch(endPace(requestId));
                if (response.data.error) {
                    if (options.showError === undefined || options.showError) {
                        const error = response.data;

                        store.dispatch(showModal({
                            size: "large",
                            theme: "danger",
                            header: "Szerveroldali hiba",
                            body: trace(error)
                        }));
                    }
                    reject(response.data.error);
                } else if (response.data.success !== undefined && !response.data.success) {
                    if (options.showError === undefined || options.showError) {
                        store.dispatch(showModal({
                            size: "large",
                            theme: "warning",
                            header: "Sikertelen művelet",
                            body: response.data.msg || "Hiba történt"
                        }));
                    }
                    reject(response.data);
                } else if (response.data.validation) {
                    if (options.showError === undefined || options.showError) {
                        store.dispatch(showModal({
                            size: "large",
                            theme: "warning",
                            header: "Sikertelen művelet",
                            body: <div>
                                {Object.keys(response.data.messages || {}).map((key) => {
                                    if (Array.isArray(response.data.messages[key])) {
                                        return response.data.messages[key].map((message, idx) => {
                                            return <div key={idx}>{message}</div>;
                                        })
                                    }
                                    return <div>{response.data.messages[key]}</div>;
                                })}
                            </div>
                        }));
                    }
                    reject(response.data);
                } else {
                    resolve(response.data);
                }
            }
            let disposition = null;
            let type = null;
            Object.keys(response.headers).map((key) => {
                if (key.toLowerCase() === "content-disposition") {
                    disposition = ((contentDisposition.parse(response.headers[key]) || {}).parameters || {}).filename || "download";
                }
                if (key.toLowerCase() === "content-type") {
                    type = response.headers[key];
                }
            });
            if (disposition && type) {
                response.data.filename = disposition;
                finish(response);
            } else {
                const reader = new FileReader();
                reader.onload = () => {
                    /*if (type.indexOf("json") !== -1 || type === null) {
                        response.data = JSON.parse(reader.result);
                    } else {
                        response.data = reader.result;
                    }*/
                    try {
                        response.data = JSON.parse(reader.result);
                    } catch (e) {
                        response.data = reader.result;
                    }
                    finish(response);
                };
                reader.readAsText(response.data);
            }
        });
        request.catch((e) => {
            //store.dispatch(endPace(requestId));
            if (!(e instanceof axios.Cancel) && e.message) {
                const finish = (e) => {
                    reject(e);
                }
                const reader = new FileReader();
                reader.onload = () => {
                    /*if (type.indexOf("json") !== -1 || type === null) {
                        response.data = JSON.parse(reader.result);
                    } else {
                        response.data = reader.result;
                    }*/
                    try {
                        e.response.data = JSON.parse(reader.result);
                    } catch (_e) {
                        e.response.data = reader.result;
                    }
                    finish(e);
                };
                reader.readAsText(e.response.data);
            }
        });
    });
    r.abort = () => {cancel()};
    return r;
}

const request = (method, requestParams, postParams, options) => {
    return rawRequest(options.url !== undefined ? options.url : "index.php", method, requestParams, postParams, options);
}

export const sendRequest = (params, options = {}) => {
    return request("get", params, {}, options);
}
export const postData = (actionparams, requestparams = {}, options = {}) => {
    return request("post", requestparams, actionparams, options);
}

export const fileUpload = (actionparams, params = {}, options = {}) => {
    return request("post", params, actionparams, options);
}